import styled from 'styled-components'

export const SpanLink = styled.span`
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`